export default __webpack_public_path__ + "static/media/house3.5e4e0922.jpg";